"use client";
import React, { FC } from "react";
import { useTranslations } from "next-intl";

import ParcelsListWrapper from "@/components/dashboard/parcels/parcels-list-wrapper";
import ParcelsNavigation from "@/components/dashboard/parcels/parcels-navigation";
import ParcelsModal from "@/components/dashboard/parcels/modal/parcels-modal";
import UserInfo from "@/components/dashboard/parcels/user-info/user-info";
// import UserProgress from "@/components/dashboard/parcels/user-progress/user-progress";
import UpcomingBills from "@/components/dashboard/parcels/upcoming-bills/upcoming-bills";
import CourierModal from "@/components/dashboard/courier-service/courier-modal";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

type TParcelsLayoutProps = {
  children: React.ReactNode;
};

const ParcelsLayout: FC<TParcelsLayoutProps> = ({ children }) => {
  const t = useTranslations();
  const theme = useTheme();

  return (
    <>
      <div className="xl:grid-cols-3f mb-[30px] grid gap-4 lg:grid-cols-2">
        <UserInfo />

        {/* <UserProgress /> */}
        <UpcomingBills />
      </div>
      <ParcelsListWrapper>
        {theme !== Theme.GEORGIA && (
          <h1 className="mb-6 text-xl font-bold uppercase text-[#121212]">
            {t("inbound_parcels")}
          </h1>
        )}
        <div id="parcels-navigation">
          <ParcelsNavigation />
        </div>
        {children}
      </ParcelsListWrapper>
      <ParcelsModal />
      <CourierModal />
    </>
  );
};

export default ParcelsLayout;
